// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6">
            <path
                fill="currentColor"
                d="M4.4998827,5.25 C4.30797637,5.25 4.11597633,5.17675781 3.96972656,5.03027344 L0.219726562,1.28027344 C-0.0732421875,0.987304688 -0.0732421875,0.512695312 0.219726562,0.219726562 C0.512695312,-0.0732421875 0.987304688,-0.0732421875 1.28027344,0.219726562 L4.4998827,3.44062471 L7.72019506,0.220312357 C8.01316381,-0.0726563931 8.48777318,-0.0726563931 8.78074193,0.220312357 C9.07371068,0.513281107 9.07371068,0.987890482 8.78074193,1.28085923 L5.03074193,5.03085923 C4.88425756,5.17734361 4.69207013,5.25 4.4998827,5.25 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(ArrowDown);
